<template>
  <div>
    <el-tabs type="border-card" class="maintab" style="overflow: auto">
      <el-tab-pane>
        <span slot="label"><i class="el-icon-document"></i>维修保养费用统计</span>
        <maintain-cost ref="MaintainCost" :carList="carList" />
      </el-tab-pane>
      <el-tab-pane>
        <span slot="label"><i class="el-icon-s-cooperation"></i>加油费用统计</span>
        <oil-cost ref="OilCost" :carList="carList" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import MaintainCost from './components/MaintainCost';
import OilCost from './components/OilCost';
import { carList } from '@/api/cars'
export default {
  name: 'CarStatistic',
  components: {
    MaintainCost,
    OilCost
  },
  data() {
    return {
      carList: [],
    }
  },
  mounted() {
    this.getCarList()
  },
  methods: {
    async getCarList() {
      const { data: res } = await carList().catch(err => err)
      if (res) {
        this.carList = res
      }
    }
  },
}
</script>
<style scoped lang="less">
</style>
